import commonReadyInstruction from '../sounds/ready_screen_common.mp3';
import clickOk from '../sounds/click_ok.mp3';

const AUDIO_INSTRUCTIONS = {
    commonReadyInstruction,
    clickOk,
};

export default AUDIO_INSTRUCTIONS;
